import { ReactNode } from 'react'

import { getIsIdentityVerificationFinished } from '@/domain/identity-verification'
import { PermissionResolverFactory } from '@/domain/permissions'
import { getIsTaxRegistrationFinished } from '@/domain/tax-registration'
import { useProfile } from '@/store/profile'

import { PermissionContext } from './permission-context'

export const PermissionProvider = ({ children }: { children: ReactNode }) => {
    const profile = useProfile()

    if (!profile.fetchSuccessful) return null

    const hasCompletedIdentityVerification = getIsIdentityVerificationFinished(profile.identityVerificationStatus)
    const hasCompletedTaxRegistration = getIsTaxRegistrationFinished(profile.taxRegistrationStatus)

    const permissionResolver = new PermissionResolverFactory().createPermissionResolver({
        isOnboarding: profile.isOnboarding ?? true,
        hasSubscription: profile.hasSubscription,
        subscriptionType: profile.isCompany
            ? 'company'
            : profile.isBookkeepingOptedIn
              ? 'premiumSelfEmployed'
              : 'selfemployed',
        hasCancelledSubscription: profile.hasCancelledSubscription,
        isSelfEmployed: profile.isSelfEmployed ?? false,
        variant: profile.variant ?? null,
        hasQtrAnnualSummaries: profile.hasQuarterlyTaxReturnsAnnualSummaries,
        hasCompletedCompanyOnboarding:
            getIsIdentityVerificationFinished(profile.identityVerificationStatus) || profile.hasQuarterlyTaxReturns,
        hasCompletedSelfEmployedOnboarding:
            (!profile.isNewSelfEmployed && hasCompletedIdentityVerification) ||
            (profile.isNewSelfEmployed && hasCompletedTaxRegistration) ||
            profile.hasQuarterlyTaxReturns,
    })

    return (
        <PermissionContext.Provider value={{ permissionResolver: permissionResolver }}>
            {children}
        </PermissionContext.Provider>
    )
}
